//НАПИСАТЬ УНИВЕРСАЛЬНУЮ ПРОГРЕССИВНУЮ ЗАГРУЗКУ
import * as THREE from "three";
import * as Camera from "./Camera.js";
import { DebugEnvironment } from "three/examples/jsm/Addons.js";

export const sceneHandler = {
    init: init,
};

let scene;

function init(incomingScene) {
    scene = incomingScene;
    scene.background = new THREE.Color(0xffffff);

    setUpCameraFromImported("camera", "camera_target");

    createLighting();
    applyRoomLighting();

    // scene.getObjectByName("floor_bg").material.side = THREE.FrontSide;
    scene.getObjectByName("floor_bg").position.y = 10;

    const logo = document.querySelector("header img");

    const themeBtn = document.getElementById("theme-btn");
    const themeIcon = document.getElementById("theme-icon");

    themeBtn.addEventListener("pointerdown", () => {
        if (servObj.colorTheme === "light") {
            scene.fog?.color.set(0x0d1622);
            scene.background.set(0x0d1622);

            servObj.colorTheme = "dark";

            scene.getObjectByName("floor_bg").material.color.set(0x0d1622);
            scene.getObjectByName("light_ambient").color.set(0xffffff);

            logo.src = "./images/logo_dark-theme.svg";
            themeIcon.src = "./images/icons/sun.svg";

            servObj.building.changeSizesColor(0xffffff);
        } else {
            scene.fog?.color.set(servObj.isRedactorMode ? 0xe7e8ec : 0xffffff);
            scene.background.set(servObj.isRedactorMode ? 0xe7e8ec : 0xffffff);

            servObj.colorTheme = "light";

            scene.getObjectByName("floor_bg").material.color.set(0xf0f1f6);
            scene.getObjectByName("light_ambient").color.set(0xffffff);

            logo.src = "./images/logo_light-theme.svg";
            themeIcon.src = "./images/icons/moon.svg";

            servObj.building.changeSizesColor(0x000000);
        }
    });
}

function setUpCameraFromImported(importedCameraName, importedCameraTargetName) {
    const importedCamera = scene.getObjectByName(importedCameraName);
    const importedCameraTarget = scene.getObjectByName(importedCameraTargetName);

    const camera = new Camera.Perspective(container3D.canvas, importedCamera.fov, importedCamera.aspect);

    camera.name = importedCamera.name;
    camera.controls.setLookAt(
        -21.499592010981726,
        11.497791436066983,
        21.899678938099306,
        importedCameraTarget.position.x,
        importedCameraTarget.position.y,
        importedCameraTarget.position.z,
    );

    scene.setActiveCamera(camera);
}

export function setMaterialEnvMap(material) {
    const pmremGenerator = new THREE.PMREMGenerator(scene.renderer);
    material.envMap = pmremGenerator.fromScene(new DebugEnvironment()).texture;
}

function createLighting() {
    const lightMain = new THREE.DirectionalLight(0xffffff);
    lightMain.name = "light_main";
    lightMain.intensity = 2;
    lightMain.position.set(8, 20, 8);
    lightMain.castShadow = true;
    lightMain.shadow.intensity = 0.3;
    lightMain.shadow.camera.near = 1;
    lightMain.shadow.camera.far = 1000;
    lightMain.shadow.mapSize.set(2048, 2048);
    lightMain.shadow.map?.setSize(2048, 2048);
    lightMain.shadow.normalBias = 0.1;
    lightMain.shadow.camera.top = 5;
    lightMain.shadow.camera.bottom = -5;
    lightMain.shadow.camera.left = 5;
    lightMain.shadow.camera.right = -5;
    lightMain.shadow.camera.updateProjectionMatrix();

    lightMain.shadow.radius = 8;
    lightMain.shadow.bias = 0; //0.0001
    lightMain.shadow.blurSamples = 16;

    const notCastingObjs = [];
    const notRecievingObjs = [];
    setShadowBehaviour(scene, notCastingObjs, notRecievingObjs);

    const light2 = new THREE.DirectionalLight(0xffffff); //0xffdfbf
    light2.name = "light_2";
    light2.intensity = 0.6;
    light2.position.set(-10, 0, -5);

    const light3 = new THREE.DirectionalLight(0xffffff); //0xffdfbf
    light3.name = "light_3";
    light3.intensity = 0.6;
    light3.position.set(8.5, 0, 5);

    const light4 = new THREE.DirectionalLight(0xffffff); //0xffdfbf
    light4.name = "light_4";
    light4.intensity = 0.6;
    light4.position.set(-5, -0.1, -5);

    const lightAmbient = new THREE.AmbientLight(0xffffff); //0xcee3ff
    lightAmbient.name = "light_ambient";
    lightAmbient.intensity = 1.5;

    scene.add(lightMain, light2, light3, light4, lightAmbient);
    lightMain.shadow.needsUpdate = true;
}

export function setShadowBehaviour(group, notCastingObjs, notRecievingObjs) {
    group.traverse((obj) => {
        if (obj.isMesh && !obj.type.includes("Line")) {
            obj.receiveShadow = true;
            obj.castShadow = true;
            if (notCastingObjs.includes(obj.name) || notCastingObjs.includes(obj.parent.name)) obj.castShadow = false;
            if (notRecievingObjs.includes(obj.name) || notRecievingObjs.includes(obj.parent.name))
                obj.receiveShadow = false;
        }
    });
}

export function applyRoomLighting() {
    scene.getObjectByName("floor_bg").visible = false;

    const lightMain = scene.getObjectByName("light_main");
    const light2 = scene.getObjectByName("light_2");
    const light3 = scene.getObjectByName("light_3");
    const light4 = scene.getObjectByName("light_4");

    lightMain.intensity = 1.8;
    lightMain.position.set(8, 20, 8);

    lightMain.shadow.intensity = 0.5;
    lightMain.shadow.radius = 8;
    lightMain.shadow.bias = 0;
    lightMain.shadow.needsUpdate = true;

    light2.intensity = 1;
    light2.position.set(10, 0, 5);

    light3.intensity = 1;
    light3.position.set(-10, 0, -5);

    light4.intensity = 0;

    lightMain.shadow.camera.top = 5;
    lightMain.shadow.camera.bottom = -5;
    lightMain.shadow.camera.left = 5;
    lightMain.shadow.camera.right = -5;
    lightMain.shadow.camera.updateProjectionMatrix();

    const color = servObj.colorTheme === "light" ? 0xffffff : 0x0d1622;
    scene.fog = null;
    scene.background = new THREE.Color(color);
}

export function applyConfiguratorLighting() {
    scene.getObjectByName("floor_bg").visible = true;
    scene.getObjectByName("floor_bg").parent.visible = true;

    const lightMain = scene.getObjectByName("light_main");
    const light2 = scene.getObjectByName("light_2");
    const light3 = scene.getObjectByName("light_3");
    const light4 = scene.getObjectByName("light_4");

    lightMain.intensity = 2;
    lightMain.position.set(8, 20, 8);

    lightMain.shadow.intensity = 0.3;
    lightMain.shadow.radius = 8;
    lightMain.shadow.bias = 0; //0.0001
    lightMain.shadow.needsUpdate = true;

    light2.intensity = 0.6;
    light2.position.set(-10, 0, 5);

    light3.intensity = 0.6;
    light3.position.set(8.5, -1, 5);

    light4.intensity = 0.6;
    light4.position.set(-5, -0.1, -5);

    lightMain.shadow.camera.top = 8;
    lightMain.shadow.camera.bottom = 1;
    lightMain.shadow.camera.left = 4;
    lightMain.shadow.camera.right = -4;
    lightMain.shadow.camera.updateProjectionMatrix();

    const color = servObj.colorTheme === "light" ? 0xe7e8ec : 0x0d1622;
    scene.fog = new THREE.Fog(new THREE.Color(color), 20, 40);
    scene.background = new THREE.Color(color);
}
